import { render, staticRenderFns } from "./ds-carousel.vue?vue&type=template&id=1d899142&scoped=true&"
import script from "./ds-carousel.vue?vue&type=script&lang=ts&"
export * from "./ds-carousel.vue?vue&type=script&lang=ts&"
import style0 from "./ds-carousel.vue?vue&type=style&index=0&id=1d899142&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d899142",
  null
  
)

export default component.exports